import { render } from "./PaymentTile.vue?vue&type=template&id=7b79a41a"
import script from "./PaymentTile.vue?vue&type=script&lang=js"
export * from "./PaymentTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__